import RadioGroup from 'devextreme-react/radio-group'
import React, { FC, useState } from 'react'
import { InputNumber, InputText } from '../../../../components/input'

import { IInputArrayFormProps, IInputArrayDataStructureItem } from '../../../../components/input/arrayData'
import { CreateNotification } from '../../../../components/notifier'
import { Button } from '../../../../modules/button'
import { InputWraper, useForm } from '../../../../modules/form'
import { ObjectUtils } from '../../../../modules/utils'
import { InputAutoComplete } from '../../../../components/input/auto-complete'

export const RepairProcessContentStructure: IInputArrayDataStructureItem[] = [
  {
    name: 'NameSupplies',
    label: 'Tên vật tư',
    isVisibleOnList: true,
  },
  {
    name: 'Amount',
    label: 'Số lượng',
    isVisibleOnList: true,
  },
  {
    name: "Unit",
    label: "Đơn vị tính",
    isVisibleOnList: true,
  },
  {
    name: 'UnitPrice',
    label: 'Đơn giá',
    isVisibleOnList: true,
  },
  {
    name: 'IntoMoney',
    label: 'Thành tiền',
    isVisibleOnList: true,
  },
  {
    name: 'Plan',
    label: 'Nguồn vật tư',
    isVisibleOnList: true,
  },
  {
    name: 'Notes',
    label: 'Ghi chú',
    isVisibleOnList: true,
  },
  
]

export const RepairProcessContentForm: FC<IInputArrayFormProps> = (props) => {
  const { childFormData } = props;
  const planOptions = [  'Mua ngoài','Xuất kho'];
  const UnitSelections = ["Bộ", "Cái", "Chiếc", "Cục", "Hộp", "Cuộn", "met", "met2", "Tấm", "Cây"];
  const [unitSelected, setUnitSelected] = useState(null as any);
  const [planOptionsSelected, setPlanOptionsSelected] = useState(childFormData?.Plan ?? planOptions[0]);
  

  const { handleSubmit, getInputProps } = useForm({
    structure: props.structure.map((item => {
      return {
        ...item,
        defaultValue: ObjectUtils.getIn(childFormData, item.name) || item.defaultValue
      }
    })),
    onSubmit: (values) => {
      values.Unit = unitSelected ? unitSelected : values.Unit;
      if (!values.NameSupplies || !values.Amount || !values.Unit) {
          CreateNotification({ title: 'Thông báo', body: "Vui lòng nhập đầy đủ thông tin yêu cầu!", icon: '/icons/warning.png' });
      }
      else {
        values.Plan = planOptionsSelected;
        props.onSubmit(values)
      }
    }
  })

  const handleTextAutoCompleteChange = (value: string) => {
    setUnitSelected(value);
  }

  const handleSelectedChange = (value: any) => {
    setUnitSelected(value);
  }
  
  const onPlanOptionsChange = (e: any) => {
     setPlanOptionsSelected(e);
  }

  return (
    <div className="Form__add-new py-4">
      <InputWraper inputProps={getInputProps("NameSupplies")} renderInput={(s) => <InputText {...s} />} isRequired />
      <InputWraper
        inputProps={getInputProps("Unit")}
        renderInput={(s) => (
          <InputAutoComplete
            {...s}
            options={UnitSelections}
            onChange={handleTextAutoCompleteChange}
            onSelectedChange={handleSelectedChange}
          />
        )}
        isRequired
      />
      <InputWraper inputProps={getInputProps("Amount")} renderInput={(s) => <InputNumber {...s} />} isRequired />
      <InputWraper inputProps={getInputProps("UnitPrice")} renderInput={(s) => <InputNumber {...s} />} />
      <InputWraper
        inputProps={getInputProps("IntoMoney")}
        renderInput={(s) => (
          <InputNumber
            {...s}
            value={getInputProps("Amount").value * getInputProps("UnitPrice").value}
            isDisabled={true}
          />
        )}
      />
      <InputWraper
        inputProps={getInputProps("Plan")}
        renderInput={(s) => (
          <RadioGroup
            {...s}
            id="radio__group-content"
            onValueChange={onPlanOptionsChange}
            dataSource={planOptions}
            value={planOptionsSelected ? planOptionsSelected : planOptions[0]}
            layout="horizontal"
          />
        )}
      />
      <InputWraper inputProps={getInputProps("Notes")} renderInput={(s) => <InputText {...s} />} />

      <div className="foot">
        <Button type="button" label="Xác nhận" onClick={handleSubmit} />
      </div>
    </div>
  );
}